import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon-position" }
const _hoisted_2 = { class: "ms-4" }
const _hoisted_3 = { class: "font-medium font-weight-300" }
const _hoisted_4 = { class: "font-weight-600 order-info__data-item m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["col-6 d-flex align-items-center", 'order-info' + _ctx.dataClassName])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "icon-item", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.translateKey)), 1),
      _createElementVNode("h5", _hoisted_4, [
        _renderSlot(_ctx.$slots, "order-info", {}, undefined, true)
      ])
    ])
  ], 2))
}